import { FC } from 'react';

interface IMenuCardProps {
    index: number,
    name: string,
    image: string,
    price: number,
    description: string,
}

export const MenuCard: FC<IMenuCardProps> = ({ index, name, image, price, description }) => {
    return (
        <div key={index}>
            <div className="flex flex-row lg:flex-col h-full">
                <div className={`w-[45%] md:w-auto ${index === 1 || index === 3 ? 'lg:order-1' : 'order-none'}`}>
                    <img src={image} alt={name} />
                </div>

                <div className="bg-[#fff3e4] flex-1 flex flex-col justify-center px-6 lg:p-12 lg:max-h-[250px] xl:max-h-max">
                    <div className="text-justify">
                        <div className="text-xl font-semibold text-dark xl:text-2xl">{name}</div>
                        <div className="my-1 text=[20px] lg:text-[40px] lg:my-6 text-accent font-semibold">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(price)}</div>
                        <div>{description}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}
